const TimeChoiceDelivery = () => {
    return (
    <div>
      <div className="flex flex-col justify-center items-center">
      <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
            Time Choice Delivery
            </h1>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
              TCS Time Choice is a fulfilment service that enables customers to select the date and time when 
              they want their orders to be received. Deliveries are usually made within the threshold of one hour—no later 
              than 30 minutes after the customer’s chosen time. Bundling the Time Choice option with their chosen shipment 
              mode allows customers to carry on with their routines as planned, without putting aside the whole day for 
              receiving an important delivery. The promised times depend upon the intended destination within the network.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
            <img src="/DomesticScrollingBanner/image4.jpg" alt="" className="rounded-md max-w-[100%]"/>
          </div>
        </div>
      
      </div>
    </div>

    )
};
export default TimeChoiceDelivery;